import React from 'react'
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const StandingsTotal = ({total_length,total_weight, day_wise_fish_records,culled_fish_records,tourney_type,fish_caught,top_max_fish_length,top_max_fish_weight,measurement_type,maxFish,scoresId, showDropdown=false, length_measurement_symbol, weight_measurement_symbol,estimated_total_fish_weight,hide_fish_records ,metric = '"', total_of_day_wise_fish_count, show_multi_day_fish_count, total_fish_points, show_points}) => {
  
  const toggleScores = (e, scoresId) => {
    e.preventDefault()
    const row = document.getElementById(scoresId)
    const up = document.getElementById(scoresId+'ToggleUp')
    const down = document.getElementById(scoresId+'ToggleDown')

    row.classList.toggle("hidden")
    up.classList.toggle("hidden")
    down.classList.toggle("hidden")
  }

  //console.log('Day wise fish records::' ,day_wise_fish_records);
  //console.log('culled fish records::' ,culled_fish_records);
  //console.log('Tourney type value passed::',tourney_type);

  //console.log('Show dropdown value passed::', showDropdown);
  
  function getEstimateWeightScore(){

    return (

      (estimated_total_fish_weight !== undefined && estimated_total_fish_weight != 0 ) ?

      <OverlayTrigger placement="bottom" overlay={RenderWeightTooltip} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} >
      {/* 25/Jun/2025 :: TP-409 Jira card :: Added condition to show points*/}
      <>
        {show_points == 1 ? (
          <>
          <div className="fish-total">
            Points {total_fish_points}
          </div>
           <div className="fish-total fish-total-2">{total_length}{length_measurement_symbol}
        </div>
        </>
        ) : 
        <div className="fish-total">{total_length}{length_measurement_symbol}
        </div>
        }
      </>
    
      </OverlayTrigger>

      :
      // TP-409 jira card :: need to add points here
      // <div className="fish-total">{total_length}{length_measurement_symbol}
      // </div>

      <>
        {show_points == 1 ? (
          <>
          <div className="fish-total">
            Points {total_fish_points}
          </div>
           <div className="fish-total fish-total-2">{total_length}{length_measurement_symbol}
        </div>
        </>
        ) : 
        <div className="fish-total">{total_length}{length_measurement_symbol}
        </div>
        }
      </>



    ) 
    
  }

  function getEstimateApexWeightScore(){

    return (

      (estimated_total_fish_weight !== undefined && estimated_total_fish_weight != 0 ) ?

      <OverlayTrigger placement="bottom" overlay={RenderWeightTooltip} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} >
    
      <div className="fish-xlf-apex-total">{total_length}{length_measurement_symbol}
      </div>
    
      </OverlayTrigger>

      :

      <div className="fish-xlf-apex-total">{total_length}{length_measurement_symbol}
      </div>



    ) 
    
  }

  function RenderWeightTooltip(props){

    return(

      (estimated_total_fish_weight !== undefined && estimated_total_fish_weight != 0 ) ?
     
      (hide_fish_records && hide_fish_records == '1' ) ?
      <Tooltip>

      </Tooltip>
      :

      <Tooltip {...props}>
     
        Estimated weight for your {total_length}{length_measurement_symbol} is { estimated_total_fish_weight } lbs
 
      </Tooltip>

      :
      
      <Tooltip {...props}>

      </Tooltip>

    )
     
    
  }

    
  // Check for the measurement type to show totals
  // Change added on 03-15-2021
  if(measurement_type == 'length'){
    const totalDisplay = showDropdown 
    ? <td style={{textAlign : 'center'}}>
        <a href="#" onClick={(e) => toggleScores(e, scoresId, scoresId+'Toggle')} style={{textDecoration : 'none', cursor: 'pointer'}}>
          
        { (tourney_type != 14 ) ?  getEstimateWeightScore() : null }
          
        { (tourney_type == 14 ) ?  <div className="fish-total">{ (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Fish` : null }</div> : null }
        { (tourney_type == 14 ) ?  getEstimateApexWeightScore() : null } 
        { (tourney_type == 14 ) ? <div className="fish-xlf-apex-small"><br></br>{ (top_max_fish_length !== undefined && top_max_fish_length != 0 ) ? ` ${ top_max_fish_length }${length_measurement_symbol} Top - ${maxFish}` : null}  </div> : null }


        { (tourney_type == 8 ) ?  <div className="fish-count-total"> { (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Total` : null } </div>: null
          
        }

          <div className="fish-count-total">
            { (day_wise_fish_records !== undefined && day_wise_fish_records != 0 ) ? `Count ${day_wise_fish_records}` : null }
            { (culled_fish_records !== undefined && culled_fish_records != 0 ) ?  ` + ${culled_fish_records}`   : null }
          </div>

          {/* TP-409 Jira card :: Display points */}
          {/* <div className="fish-count-total">
            { (tourney_type == 1 || tourney_type == 2  ) ? (total_fish_points !== undefined && total_fish_points != 0 ) ? `Points ${total_fish_points}` : '0' : '' }
          </div> */}

          {
            
            //(estimated_total_fish_weight !== undefined && estimated_total_fish_weight != 0 ) ?
            //  <div className="fish-estimate-weight-total"> 
            //  <br/> 
              
            //  <span>{ estimated_total_fish_weight }lbs</span> 
            //  <br/> 
            //  <span className="estimate-weight-label"> est. weight </span> 
            //  </div>

            //  :
            //  null

          }
          <div className="fish-count-total">
            { /* TP-400 jira card :: Total's tab : Show Fish count total on Total's tab total column */
            (!day_wise_fish_records && !culled_fish_records && total_of_day_wise_fish_count && show_multi_day_fish_count == 1 && ((tourney_type == 3 || tourney_type == 19))) ? (
              `Total ${total_of_day_wise_fish_count} Fish`) : ''
            }
          </div>
       
          <div className="fish-count-total">
            {   
              //TP-400 Jira card :: Daywise tab - show fish count total on Day 1/Day 2/Day 3 tab's total column
              ((day_wise_fish_records !== undefined) &&
              (culled_fish_records !== undefined) &&
              (tourney_type == 3 || tourney_type == 19) && show_multi_day_fish_count == 1) 
              ? `Total ${Number(day_wise_fish_records) + Number(culled_fish_records)} fish`
              : ''
            }
          </div>

          <div id={scoresId+'ToggleDown'} className='arrow'>▼</div>
          <div id={scoresId+'ToggleUp'}  className='arrow hidden'>▲</div>
        </a>
      </td> 
    : <td style={{textAlign : 'center'}}>
      
      { (tourney_type != 14 ) ?   getEstimateWeightScore()  : null }

      { (tourney_type == 14 ) ?  <div className="fish-total">{ (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Fish` : null }</div>: null }
      
      
      { (tourney_type == 14 ) ?  getEstimateApexWeightScore() : null } 
      
      
      { (tourney_type == 14 ) ? <div className="fish-xlf-apex-small"><br></br>{ (top_max_fish_length !== undefined && top_max_fish_length != 0 ) ? ` ${ top_max_fish_length }${length_measurement_symbol} Top - ${maxFish}` : null}  </div> : null }


      { (tourney_type == 8 ) ?  <div className="fish-count-total"> { (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Total` : null } </div>: null
        
      }
       <div className="fish-count-total">
        { (day_wise_fish_records !== undefined && day_wise_fish_records != 0 ) ? `Count ${day_wise_fish_records}` : null }
        { (culled_fish_records !== undefined && culled_fish_records != 0 ) ?  ` + ${culled_fish_records}`   : null }
       </div>

       <div className="fish-count-total">
          { /* TP-400 jira card :: Total's tab : Show Fish count total on Total's tab total column */
          (!day_wise_fish_records && !culled_fish_records && total_of_day_wise_fish_count && show_multi_day_fish_count == 1 && ((tourney_type == 3 || tourney_type == 19))) ? (
            `Total ${total_of_day_wise_fish_count} Fish`) : ''
          }
       </div>
       
       <div className="fish-count-total">
          {   
            //TP-400 Jira card :: Daywise tab - show fish count total on Day 1/Day 2/Day 3 tab's total column
            ((day_wise_fish_records !== undefined) &&
            (culled_fish_records !== undefined) &&
            (tourney_type == 3 || tourney_type == 19) && show_multi_day_fish_count == 1) 
            ? `Total ${Number(day_wise_fish_records) + Number(culled_fish_records)} fish`
            : ''
          }
        </div>

       {
        
        // (estimated_total_fish_weight !== undefined && estimated_total_fish_weight != 0 ) ?
        //      <div className="fish-estimate-weight-total"> 
        //      <br/> 
              
        //      <span>{ estimated_total_fish_weight }lbs</span> 
        //      <br/> 
        //      <span className="estimate-weight-label"> est. weight </span> 
        //      </div>

        //      :
        //      null
        
        }

      </td> 
      return(
        <>
        {totalDisplay}
        </>
      )
  }else{

    const totalDisplay = showDropdown 
    ? <td style={{textAlign : 'center'}}>
        <a href="#" onClick={(e) => toggleScores(e, scoresId, scoresId+'Toggle')} style={{textDecoration : 'none', cursor: 'pointer'}}>
          
        { (tourney_type != 14 ) ?  <div className="fish-total">{total_weight} {weight_measurement_symbol}</div> : null }

        {/* Chaitraly 25/Jun/2025 :: TP-409 Jira card :: check for adding points here */}
          
        { (tourney_type == 14 ) ?  <div className="fish-total">{ (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Fish` : null }</div> : null }
        { (tourney_type == 14 ) ?  <div className="fish-xlf-apex-total">{total_weight} {weight_measurement_symbol}</div> : null } 
        { (tourney_type == 14 ) ? <div className="fish-xlf-apex-small"><br></br>{ (top_max_fish_weight !== undefined && top_max_fish_weight != 0 ) ? ` ${ top_max_fish_weight } ${weight_measurement_symbol} Top - ${maxFish}` : null}  </div> : null }


        { (tourney_type == 8 ) ?  <div className="fish-count-total"> { (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Total` : null } </div>: null
          
        }

          <div className="fish-count-total">
            { (day_wise_fish_records !== undefined && day_wise_fish_records != 0 ) ? `Count ${day_wise_fish_records}` : null }
            { (culled_fish_records !== undefined && culled_fish_records != 0 ) ?  ` + ${culled_fish_records}`   : null }
          </div>

          <div className="fish-count-total">
            { /* TP-400 jira card :: Total's tab : Show Fish count total on Total's tab total column */
            (!day_wise_fish_records && !culled_fish_records && total_of_day_wise_fish_count && show_multi_day_fish_count == 1 && ((tourney_type == 3 || tourney_type == 19))) ? (
              `Total ${total_of_day_wise_fish_count} Fish`) : ''
            }
          </div>
       
          <div className="fish-count-total">
            {   
              //TP-400 Jira card :: Daywise tab - show fish count total on Day 1/Day 2/Day 3 tab's total column
              ((day_wise_fish_records !== undefined) &&
              (culled_fish_records !== undefined) &&
              (tourney_type == 3 || tourney_type == 19) && show_multi_day_fish_count == 1) 
              ? `Total ${Number(day_wise_fish_records) + Number(culled_fish_records)} fish`
              : ''
            }
          </div>

          <div id={scoresId+'ToggleDown'} className='arrow'>▼</div>
          <div id={scoresId+'ToggleUp'}  className='arrow hidden'>▲</div>
        </a>
      </td> 
    : <td style={{textAlign : 'center'}}>
      
      { (tourney_type != 14 ) ?  <div className="fish-total">{total_weight} {weight_measurement_symbol}</div> : null }

      {/* Chaitraly 25/Jun/2025 :: TP-409 Jira card :: check for adding points here */}

      { (tourney_type == 14 ) ?  <div className="fish-total">{ (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Fish` : null }</div>: null }
      { (tourney_type == 14 ) ?  <div className="fish-xlf-apex-total">{total_weight} {weight_measurement_symbol}</div> : null } 
      { (tourney_type == 14 ) ? <div className="fish-xlf-apex-small"><br></br>{ (top_max_fish_weight !== undefined && top_max_fish_weight != 0 ) ? ` ${ top_max_fish_weight } ${weight_measurement_symbol} Top - ${maxFish}` : null}  </div> : null }


      { (tourney_type == 8 ) ?  <div className="fish-count-total"> { (fish_caught !== undefined && fish_caught != 0) ? ` ${fish_caught} Total` : null } </div>: null
        
      }
       <div className="fish-count-total">
        { (day_wise_fish_records !== undefined && day_wise_fish_records != 0 ) ? `Count ${day_wise_fish_records}` : null }
        { (culled_fish_records !== undefined && culled_fish_records != 0 ) ?  ` + ${culled_fish_records}`   : null }
       </div>

       <div className="fish-count-total">
          { /* TP-400 jira card :: Total's tab : Show Fish count total on Total's tab total column */
          (!day_wise_fish_records && !culled_fish_records && total_of_day_wise_fish_count && show_multi_day_fish_count == 1 && ((tourney_type == 3 || tourney_type == 19))) ? (
            `Total ${total_of_day_wise_fish_count} Fish`) : ''
          }
       </div>
       
       <div className="fish-count-total">
          {   
            //TP-400 Jira card :: Daywise tab - show fish count total on Day 1/Day 2/Day 3 tab's total column
            ((day_wise_fish_records !== undefined) &&
            (culled_fish_records !== undefined) &&
            show_multi_day_fish_count == 1 &&
            (tourney_type == 3 || tourney_type == 19)) 
            ? `Total ${Number(day_wise_fish_records) + Number(culled_fish_records)} fish`
            : ''
          }
        </div>

      </td> 
      return(
        <>
        {totalDisplay}
        </>
      )

  }
 

  
}

export default StandingsTotal